import OptionItem from "../../models/OptionItem";
import OptionItemTyped from "../../models/OptionItemTyped";
import { RetiraAcentos } from "../Strings/NormalizeString";

export default class SelectHelper {

    static GetIndex(item: OptionItem, list: OptionItem[]): number {
        
        if (item !== null && item !== undefined && item.toString() !== "" && list !== null && list.length > 0) {
            let index = list.findIndex(v => v.Id === item.Id);
            return index;
        }

        return 0;

    }

    static FilterOptions(text: string | undefined, list: OptionItem[]): OptionItem[] {

        var independentList = [...list]

        if (text !== null && text !== undefined && text !== "" && independentList !== null) {
            let result = independentList.filter(v =>
                v.Text.toUpperCase().includes(text.toUpperCase()) ||
                RetiraAcentos(v.Text).toUpperCase().includes(RetiraAcentos(text).toUpperCase()));

            if (result !== undefined) {
                return result;
            } else {
                return [OptionItem.NewInstance()];
            }
        }

        return independentList;

    }

    static RemoveOptions(itens: OptionItem[], list: OptionItem[]): OptionItem[] {

        var independentList = [...list]

        if (itens !== null && itens !== undefined && itens.length > 0 && independentList !== null) {

            for (let index = 0; index < itens.length; index++) {
                const item = itens[index];

                var indexToRemove = independentList.findIndex(v => v.Value.toString() === item.Value.toString());

                independentList.splice(indexToRemove, 1);
            }
        }

        return independentList;
    }

    static RemoveOptionsFromValue(value: string, list: OptionItem[]): OptionItem[] {

        var independentList = [...list]

        if (value !== null && value !== undefined && value !== "" && independentList !== null) {

            var indexToRemove = independentList.findIndex(v => v.Value === value);

            independentList.splice(indexToRemove, 1);
        }

        return independentList;
    }

    static CreateOptionsFromOption(item: OptionItem): OptionItem[] {

        var independentList : OptionItem[] = []

        independentList.push(item)

        return independentList;
    }

    static CreateOptionsFromOptionTyped<T>(item: OptionItemTyped<T>): OptionItemTyped<T>[] {

        var independentList : OptionItemTyped<T>[] = []

        independentList.push(item)

        return independentList;
    }
}